import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllCompanyAdmins = createAsyncThunk(
  "companyAdmins/doGetAllCompanyAdmins",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doGetAllCompanyAdmins(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreateCompanyAdmin = createAsyncThunk("companyAdmins/doCreateCompanyAdmin", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateCompanyAdmin(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCompanyAdmin = createAsyncThunk("companyAdmins/doUpdateCompanyAdmin", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateCompanyAdmin(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetAllPartnerCompanyAdmins = createAsyncThunk(
  "companyAdmins/doGetAllPartnerCompanyAdmins",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doGetAllPartnerCompanyAdmins(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreatePartnerCompanyAdmin = createAsyncThunk(
  "companyAdmins/doCreatePartnerCompanyAdmin",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreatePartnerCompanyAdmin(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdatePartnerCompanyAdmin = createAsyncThunk(
  "companyAdmins/doUpdatePartnerCompanyAdmin",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdatePartnerCompanyAdmin(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
